import { storybookPlaceholderImageUrl } from "componentsV0/storybook/storybookPlaceholderImageUrl";
import { ExamContentsProps } from "./ExamContents";

export const examContentsPlaceholderProps: ExamContentsProps = {
  orientation: "horizontal",
  questionImageUrl: storybookPlaceholderImageUrl,
  answerNode: null,
};
